module.exports = __webpack_public_path__ + "0d50ab79aee4d6bbb96acf7ba72f6ef0.jpg";